// extracted by mini-css-extract-plugin
export default {"wrapper":"howditwork_wrapper__-Vkyg","hdiw":"howditwork_hdiw__HRia2","main":"howditwork_main__I97n2","sendButton":"howditwork_sendButton__O64bB"};